import { TerminalInventoryStatus } from "Infrastructure/Api/Api";

type StatusOptionsInput = {
  hasMerchant: boolean;
  hasHunter: boolean;
  isTmsRegistered: boolean;
};

/**
 * Which statuses make sense for the piece's links: merchant placement comes from Orbit L, hunter
 * from the assignment field; Shipped is a Mo.one back-office step (no hunter); a TMS-provisioned
 * piece can only be returned through the Orbit L swap flow.
 */
export const getStatusOptions = ({
  hasMerchant,
  hasHunter,
  isTmsRegistered,
}: StatusOptionsInput): Array<TerminalInventoryStatus> => {
  if (!hasMerchant) {
    return [
      hasHunter
        ? TerminalInventoryStatus.AssignedToHunter
        : TerminalInventoryStatus.InStock,
      TerminalInventoryStatus.Returned,
    ];
  }

  return [
    TerminalInventoryStatus.AssignedToMerchant,
    ...(hasHunter ? [] : [TerminalInventoryStatus.Shipped]),
    TerminalInventoryStatus.WithMerchant,
    // Deployed means handed over AND provisioned — an unregistered piece can't process payments.
    ...(isTmsRegistered
      ? [TerminalInventoryStatus.Deployed]
      : [TerminalInventoryStatus.Returned]),
  ];
};
